<template>
  <div class="modal-window-body active" id="search-results-empty">
    <div class="center-container">
      <div class="center-content">
        <div class="placeholder-icon"><svg width="44px" height="44px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-search"></use></svg></div>
        <h2 class="bold">Fant ingen treff</h2>
        <p>Søket returnerte ingen treff. <br>Prøv på nytt med et annet søkeord.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheMainSearchNormalResultEmpty'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TheMainSearchNormalResultEmpty.vue